/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { CollectionListItem } from './collection-list-item';
import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface CollectionListUiModuleBody
 */
export interface CollectionListUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof CollectionListUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionListUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionListUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionListUiModuleBody
     */
    moduleType: CollectionListUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof CollectionListUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof CollectionListUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof CollectionListUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof CollectionListUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof CollectionListUiModuleBody
     */
    title: LocalizedFieldBody;
    /**
     * 
     * @type {string}
     * @memberof CollectionListUiModuleBody
     */
    templateUrlPath: string;
    /**
     * 
     * @type {Array<CollectionListItem>}
     * @memberof CollectionListUiModuleBody
     */
    collections: Array<CollectionListItem>;
}

/**
    * @export
    * @enum {string}
    */
export enum CollectionListUiModuleBodyModuleTypeEnum {
    COLLECTION_LIST = 'COLLECTION_LIST'
}



